import { useMutation } from 'react-query';
import { useZoneContext } from '../../../contexts/useZoneContext';

export interface ISaveDocumentMetaData {
    documentGuid: string;
    fileName: string;
    documentCategoryTypeIds: number[];
}

export const useSaveDocumentMetaDataMutation = () => {
    const { zoneApiClient } = useZoneContext();
    return useMutation({
        mutationFn: async (document: ISaveDocumentMetaData) => {
            const response = await zoneApiClient.saveDocumentMetaData(document);

            if (!response?.httpResponse.ok) {
                throw new Error('Failed to update document');
            }

            return response;
        },
    });
};
